import { ChangeEvent } from 'react';

import { AnyFunction } from '../../../../../types/AnyFunction';

export const onChangeInput =
  <Fn extends AnyFunction>(fn: Fn) =>
  (event: ChangeEvent<HTMLInputElement>): ReturnType<Fn> =>
    fn(event.target.value);
